import React from 'react';
import './RolemodelCards.scss'
import rolemodelsList2024 from './rolemodels_2024.json'
import rolemodelsList2025 from './rolemodels_2025.json'
import rolemodelsList2026 from './rolemodels_2026.json'	
import Flip from 'gsap/Flip';
import gsap from 'gsap';

interface RolemodelCardsProps {
	lang: string;
	year: string;
}

interface RolemodelType {
	id: number,
	image: string,
	text: string,
	text_en: string
}

const handleClick = (id: number) => {
	const card = document.getElementById(id.toString())
	const image = card?.getElementsByClassName('image')[0]
	const text = card?.getElementsByClassName('text')[0]
	const textContainer = card?.getElementsByClassName('text-container')[0]

	const state = Flip.getState('.rolemodel-card, .image, .text-container, .text, .footer, .pointer, .header, .sidebar')
	card?.classList.toggle('col-md-3')
	card?.classList.toggle('col-md-12')
	image?.classList.toggle('col-md-3')
	text?.classList.toggle('d-none')
	textContainer?.classList.toggle('col-md-9')
	textContainer?.classList.toggle('no-width')
	Flip.from(state, {
			nested: true,
			absolute: true,
			ease: "power2.inOut",
            duration: 1,
			prune: true,
            onEnter: elements => gsap.fromTo(elements, {opacity: 0}, {opacity: 1, duration:1}),
            onLeave: elements => gsap.fromTo(elements, {opacity: 1}, {opacity: 0, duration:1}),
			// onComplete: () => {if(cont) cont.style.minHeight = '0'}
		})
}

const RolemodelCards: React.FC<RolemodelCardsProps> = (props: RolemodelCardsProps) => {
	let rolemodelList = null
	if (props.year==='2024') {
		rolemodelList = rolemodelsList2024 as RolemodelType[]
	} else if (props.year==='2025') {
		rolemodelList = rolemodelsList2025 as RolemodelType[]
	} else if (props.year==='2026') {
		rolemodelList = rolemodelsList2026 as RolemodelType[]
	} else {return(<></>)}
	return (<div className='row rolemodelCards'>
		{
			rolemodelList.map((model, index) => {
				let text = props.lang==='nl' ? model.text : model.text_en
				if (text === "") {
					text = props.lang==='nl' ? model.text_en : model.text
				}
				if (text !== "") {
					return (<div id={model.id.toString()} onClick={()=>handleClick(model.id)} className='col-md-3 rolemodel-card row cursor-pointer' key={model.id}>
						<img alt={model.image} className='image' src={process.env.PUBLIC_URL + '/images/rolemodels/' + props.year + '/' + model.image}></img> 
						<div className="no-size"><svg className="pointer" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">!Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com License - https://fontawesome.com/license/free Copyright 2025 Fonticons, Inc.<path d="M160 64c0-8.8 7.2-16 16-16s16 7.2 16 16l0 136c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c8.8 0 16 7.2 16 16c0 10.3 6.6 19.5 16.4 22.8s20.6-.1 26.8-8.3c3-3.9 7.6-6.4 12.8-6.4c7.8 0 14.3 5.6 15.7 13c1.6 8.2 7.3 15.1 15.1 18s16.7 1.6 23.3-3.6c2.7-2.1 6.1-3.4 9.9-3.4c8.8 0 16 7.2 16 16l0 16 0 104c0 39.8-32.2 72-72 72l-56 0-59.8 0-.9 0c-37.4 0-72.4-18.7-93.2-49.9L50.7 312.9c-4.9-7.4-2.9-17.3 4.4-22.2s17.3-2.9 22.2 4.4L116 353.2c5.9 8.8 16.8 12.7 26.9 9.7s17-12.4 17-23l0-19.9 0-256zM176 0c-35.3 0-64 28.7-64 64l0 197.7C91.2 238 55.5 232.8 28.5 250.7C-.9 270.4-8.9 310.1 10.8 339.5L78.3 440.8c29.7 44.5 79.6 71.2 133.1 71.2l.9 0 59.8 0 56 0c66.3 0 120-53.7 120-120l0-104 0-16c0-35.3-28.7-64-64-64c-4.5 0-8.8 .5-13 1.3c-11.7-15.4-30.2-25.3-51-25.3c-6.9 0-13.5 1.1-19.7 3.1C288.7 170.7 269.6 160 248 160c-2.7 0-5.4 .2-8 .5L240 64c0-35.3-28.7-64-64-64zm48 304c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96zm48-16c-8.8 0-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96c0-8.8-7.2-16-16-16zm80 16c0-8.8-7.2-16-16-16s-16 7.2-16 16l0 96c0 8.8 7.2 16 16 16s16-7.2 16-16l0-96z"/></svg></div>
						<div className='text-container no-width'><p className='text d-none' dangerouslySetInnerHTML={{ __html: text}}></p></div>
					</div>)
				} else {
					return (<div id={model.id.toString()} className='col-md-3 rolemodel-card row' key={model.id}>
						<img alt={model.image} className='image' src={process.env.PUBLIC_URL + '/images/rolemodels/' + props.year + '/' + model.image}></img> 
						<div className='text-container no-width'><p className='text d-none'></p></div>
					</div>)
				}
			})
		}
	</div>)
}

export default RolemodelCards